// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEmailAttention_root__6sGWp","marketplaceStroke":"IconEmailAttention_marketplaceStroke__1OxqV","attentionStroke":"IconEmailAttention_attentionStroke__YueWc"};